function loadScriptWithJQuery(src) {
	return $.Deferred(function (deferred) {
		const script = $('<script>', {
			src: src,
			type: "text/javascript",
			async: true
		}).on('load', function () {
			deferred.resolve(`Script loaded: ${src}`);
		}).on('error', function () {
			deferred.reject(new Error(`Failed to load script: ${src}`));
		});

		$('head').append(script);
	}).promise();
}

function reinitializeScriptWithJQuery(src) {
	const $existingScript = $(`script[src="${src}"]`);
	if ($existingScript.length) {
		$existingScript.remove();
		console.log(`Existing script removed: ${src}`);
	}

	loadScriptWithJQuery(src)
		.done(function (result) {
			console.log(result);
		})
		.fail(function (error) {
			console.error(error.message);
		});
}
$(document).ready(function () {
	jQuery(document).on('click', '.variant-picker__option label', function () {
		const scriptSrc = "https://d3p29gcwgas9m8.cloudfront.net/assets/js/index.js";

		setTimeout(() => {
			reinitializeScriptWithJQuery(scriptSrc);
		}, 300);
	});
});

function checkForStock() {
	const escBlock = document.querySelector('#esc-oos-form');
	const submitButton = document.querySelector('buy-buttons button');

	if (submitButton.hasAttribute('disabled') || submitButton.disabled) {
		escBlock.style.display = 'block';
	} else {
		escBlock.style.display = 'none';
	}
}

document.addEventListener("click", e => {
    const variants = e.target.closest("variant-picker");
    if (variants) {
        setTimeout(checkForStock, 0);
    }
});
